import { toRem } from './helpers'
const fontFamily = 'Poppins, Helvetica, Arial, sans-serif'

export default {
  fontFamily,
  styles: {
    // http://www.bbc.co.uk/gel/guidelines/typography
    Canon: {
      tag: 'h1',
      fontSize: toRem(200),
      fontWeight: 800,
      lineHeight: toRem(56),
      fontFamily,
    },
    Trafalgar: {
      tag: 'h1',
      fontSize: toRem(36),
      fontWeight: 800,
      lineHeight: toRem(40),
      fontFamily,
    },
    Paragon: {
      tag: 'h2',
      fontSize: toRem(18),
      fontWeight: 500,
      lineHeight: toRem(24),
      fontFamily,
    },
    /* Based on design - start */
    DoublePica: {
      tag: 'h3',
      fontSize: toRem(16),
      fontWeight: 400,
      lineHeight: toRem(24),
      fontFamily,
    },
    GreatPrimer: {
      tag: 'h4',
      fontSize: toRem(14),
      fontWeight: 500,
      lineHeight: toRem(21),
      fontFamily,
    },
    BodyCopy: {
      tag: 'p',
      fontSize: toRem(14),
      fontWeight: 400,
      lineHeight: toRem(21),
      fontFamily,
    },
    /* Based on design - end */
    Brevier: {
      tag: 'p',
      fontSize: toRem(12),
      fontWeight: 500,
      lineHeight: toRem(18),
      fontFamily,
    },
  },
}
